import { PropsWithChildren } from "react"
import { useEmptyListParams } from "./useEmptyListParams"
import { ListParamsContext } from "."

export function EmptyListParamsProvider(props: PropsWithChildren<unknown>) {
    const params = useEmptyListParams()
    return <ListParamsContext.Provider value={params}>{props.children}</ListParamsContext.Provider>
}
